/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { Area, AreaFromJSON, AreaFromJSONTyped, AreaToJSON } from "./Area";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";

/**
 *
 * @export
 * @interface AreaControllerResponse
 */
export interface AreaControllerResponse {
  /**
   *
   * @type {Area}
   * @memberof AreaControllerResponse
   */
  data?: Area;
  /**
   *
   * @type {ErrorResponse}
   * @memberof AreaControllerResponse
   */
  error?: ErrorResponse;
}

export function AreaControllerResponseFromJSON(json: any): AreaControllerResponse {
  return AreaControllerResponseFromJSONTyped(json, false);
}

export function AreaControllerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AreaControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : AreaFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function AreaControllerResponseToJSON(value?: AreaControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: AreaToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
